import React from 'react';
import PropTypes from 'prop-types';
import { EnvironmentOutlined } from '@ant-design/icons';

import { getGoogleMapsSearchUrl } from '../../helpers/maps';

function AddressLink({
  address,
  children,
  className,
  style,
  showIcon,
}) {
  const href = getGoogleMapsSearchUrl(address);
  const label = children ?? address;

  if (!href) return label ?? null;

  return (
    <a
      className={`address-link${className ? ` ${className}` : ''}`}
      style={style}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title="Open in Google Maps"
      // Several hosts (map info windows, list rows) are themselves click targets
      onClick={(e) => e.stopPropagation()}
    >
      {showIcon && <EnvironmentOutlined className="address-link-icon" />}
      {label}
    </a>
  );
}

AddressLink.propTypes = {
  address: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  showIcon: PropTypes.bool,
};

AddressLink.defaultProps = {
  address: null,
  children: null,
  className: null,
  style: {},
  showIcon: true,
};

export default AddressLink;
